<template>
  <div class="header">
    <div class="header__title">직장 정보 업데이트</div>
    <div class="header__tab">
      <input id="tab1" v-model="tabValue" type="radio" value="0" name="tabs" disabled />
      <label for="tab1" class="tab1">
        <span :class="{ circle: tabValue == 0, complete: tabValue == 1 }"></span>
        <span>정보 선택</span>
      </label>
      <input id="tab2" v-model="tabValue" type="radio" value="1" name="tabs" disabled />
      <label for="tab2" class="tab2">
        <span class="circle"></span>
        <span>약관 동의</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpdateRequestHeader",
  computed: {
    tabValue: {
      get() {
        return this.$store.state.BizInfo.tabValue;
      },
      set(value) {
        this.$store.commit("BizInfo/SET_TABVALUE", value);
      },
    },
  },
};
</script>

<style lang="" scoped></style>
